import { FileType } from "@/Common/Models/FileType";
import { ExportableFile, IExportableFile, IExportableFileLoaded } from "../ExportableFile";

interface IFileTypeTemporaryFile extends IExportableFile {
    ObjectId: string;
    totalPages?: number;
    sizeBytes?: number;
}

class FileTypeTemporaryFile extends ExportableFile implements IFileTypeTemporaryFile {
    public ObjectId: string;

    constructor(fields: IFileTypeTemporaryFile) {
        super(FileType.TemporaryFile);
        Object.assign(this, fields);
    }

    public getAttachedObject_ObjectId(): string { return this.ObjectId; }

    public FetchUrlXcom(clientTag: string, claimId: string): string {
        return `api/xcom/${clientTag}/${claimId}/api/pdf/fetch/${this.ObjectId}` + apiSettings.buildQueryString({ auth: true });
    }

    public get FetchUrl(): string {
        if (this.isExternal)
            return this.FetchUrlXcom(this.clientTag, this.claimId);

        return `api/pdf/fetch/${this.ObjectId}` + apiSettings.buildQueryString({ auth: true });
    }

    public getCleanCopy(): FileTypeTemporaryFile {
        let copyConstructor: IFileTypeTemporaryFile = {
            ObjectId: this.ObjectId,
            totalPages: this.totalPages,
            sizeBytes: this.sizeBytes,
            date: this.date,
            description: this.description
        };

        return new FileTypeTemporaryFile(copyConstructor);
    }

    public async getMeta(): Promise<number> {
        if (this.totalPages)
            return this.totalPages;

        throw "Not implemented";
    }

    protected generateFileIfNeeded(): Promise<IExportableFileLoaded> {
        return new Promise(resolve => resolve({
            OriginalExportableFile: this,
            FetchUrl: this.FetchUrl
        }));
    }
}

export { FileTypeTemporaryFile };
